import React from 'react';
//import logo from './logo.svg';
// import './App.css';

//import react router
import { Route, Router, Switch } from 'react-router-dom';  
import { createBrowserHistory } from "history";

//import pages
import Home from './pages/home';
import About from './pages/about';
import Recipes from './pages/recipes/recipes';
import Contact from './pages/contact';
import NotFound from './pages/notfound';
import Appetizers from './pages/recipes/appetizers'



import Navbar from './components/navbar';

import Footer from './components/footer';
// import RecipeRoutes from './pages/recipes/reciperoutes';
import './App.css'

const browserHistory = createBrowserHistory()

function App() {
  return (
    <div className="App">
     <Navbar/>

     <Switch>
    <Route exact path="/" component={Home}></Route>
     <Route path="/about" component={About}></Route>
     
     <Route path="/contact" component={Contact}></Route>
     
     <Route exact path="/recipes" component={Recipes}></Route>

     <Route path='/site2' component={() => { 
     window.location.href = 'http://www.steve.christopherkent.us/site2'; 
     return null;
}}/>

<Route path='/plain' component={() => { 
     window.location.href = 'http://www.steve.christopherkent.us/plain'; 
     return null;
}}/>

     <Route path="/recipes/appetizers" component={Appetizers}></Route>
     
      <Route component={NotFound}></Route>
      
     </Switch>
     <Footer/>
    </div>
  );
}

export default App;
